export const landingTranslations = {
  fr: {
    seoTitle: "Sclépios IA - Votre assistant médical IA intelligent",
    seoDesc: "L'IA médicale #1 en France. Chat IA adapté à votre niveau, flashcards intelligentes, QCM, cas cliniques. Essai gratuit 7 jours.",
    nav: {
      chatIA: "Chat IA",
      pricing: "Tarifs",
      dashboard: "Tableau de bord",
      login: "Connexion",
      freeTrial: "Essai gratuit",
    },
    hero: {
      badge: "Approuvé par +1200 soignants",
      title: "Votre assistant médical IA,",
      titleHighlight: "toujours dans votre poche",
      subtitle: "De l'étudiant au praticien, révisez et soignez mieux avec l'IA médicale la plus avancée.",
      benefit1: "Chat IA médical adapté à votre niveau",
      benefit2: "Flashcards intelligentes & QCM personnalisés",
      benefit3: "Analyse d'ordonnances & calculs médicaux",
      ctaPrimary: "Essayer 7 jours gratuit",
      ctaSecondary: "Découvrir le Chat IA",
      badgeSecure: "Données sécurisées",
      badgeNoCard: "Sans CB requise",
      badgeUsers: "1200+ soignants",
      mockupTitles: {
        chat: "Chat IA Médical",
        dashboard: "Tableau de bord",
        flashcards: "Flashcards Intelligentes",
        qcm: "QCM Personnalisés",
      },
      viewScreenshot: "Voir capture {{index}}",
      chatIA24: "Chat IA",
      flashcardsCount: "+15 000",
    },
    trust: {
      rating: "Note moyenne",
      activeUsers: "Soignants actifs",
      timePerPatient: "Gain par patient",
      rgpd: "RGPD compliant",
    },
    features: {
      title: "Tout ce dont vous avez besoin,",
      titleHighlight: "en une seule app",
      subtitle: "Des outils puissants conçus pour les professionnels de santé et étudiants",
      items: {
        chatIA: { title: "Chat IA Médical", description: "Réponses instantanées à toutes vos questions médicales, adaptées à votre niveau" },
        flashcards: { title: "Flashcards Intelligentes", description: "Mémorisation optimisée avec algorithme de répétition espacée" },
        qcm: { title: "QCM & Quiz", description: "10 000+ questions pour vous entraîner aux examens" },
        clinical: { title: "Cas Cliniques", description: "Entraînement ECN avec des cas réalistes et corrigés" },
        prescriptions: { title: "Analyse d'Ordonnances", description: "Vérification automatique des interactions et posologies" },
        calculators: { title: "50+ Calculateurs", description: "Tous les scores médicaux à portée de main" },
        sheets: { title: "Fiches de Révision", description: "Synthèses claires par spécialité médicale" },
        express: { title: "Révision Express", description: "Sessions de 5 min pour réviser entre deux patients" },
      },
    },
    chatSection: {
      badge: "Fonctionnalité Phare",
      title: "Chat IA Médical",
      titleHighlight: "Intelligent",
      subtitle: "Posez n'importe quelle question médicale et obtenez une réponse claire, structurée et adaptée à votre niveau de pratique.",
      feature1: "Adapté à votre niveau (étudiant, IDE, médecin)",
      feature2: "Sources médicales fiables (HAS, SFAR, SRLF...)",
      feature3: "Disponible 24/7, même hors-ligne",
      cta: "Essayer le Chat IA",
      assistantName: "Assistant Sclépios",
      online: "En ligne",
      inputPlaceholder: "Posez votre question médicale...",
      viewExample: "Voir exemple {{index}}",
    },
    pricing: {
      title: "Tarifs simples et",
      titleHighlight: "transparents",
      subtitle: "Choisissez le plan adapté à vos besoins. Annulation à tout moment.",
      monthly: "Mensuel",
      yearly: "Annuel",
      promoCode: "Code RETOUR30 : -30% pendant 3 mois !",
      withPromoCode: "avec code RETOUR30",
      billedYearly: "Facturé {{amount}}/an",
      mostPopular: "Plus populaire",
      teamPlan: "Plan Team pour les établissements",
      teamPrice: "19,99€/mois pour 5 utilisateurs",
      contactUs: "Nous contacter",
      plans: {
        free: {
          name: "Gratuit",
          description: "Pour découvrir l'application",
          features: ["3 messages IA par jour", "Quiz quotidien", "Forum communautaire", "Flashcards basiques"],
          cta: "Créer un compte",
        },
        essential: {
          name: "Essential",
          description: "Pour les étudiants",
          features: ["Chat IA illimité", "Flashcards illimitées", "Tous les QCM", "Statistiques basiques", "Mode hors-ligne"],
          cta: "Choisir Essential",
        },
        pro: {
          name: "Pro",
          description: "Pour les professionnels",
          features: ["Tout Essential +", "Cas cliniques interactifs", "Révision Express 5min", "Statistiques avancées", "Analyse d'ordonnances", "Export PDF"],
          cta: "Choisir Pro",
        },
      },
    },
    testimonials: {
      title: "Ils utilisent Sclépios",
      titleHighlight: "au quotidien",
      subtitle: "Rejoignez plus de 1 200 professionnels de santé satisfaits",
      verified: "Vérifié",
      viewTestimonial: "Voir témoignage {{index}}",
      statsRating: "Note moyenne",
      statsUsers: "Utilisateurs actifs",
      statsFlashcards: "Flashcards créées",
      roles: {
        emergencyDoctor: "Médecin urgentiste",
        hospitalDoctor: "Médecin hospitalier",
        icuNurse: "Infirmier en réanimation",
        cardiologyIntern: "Interne en cardiologie",
      },
      texts: {
        0: "Sclépios est devenu mon compagnon quotidien aux urgences. L'IA me fait gagner un temps précieux pour la prise de décision en situation critique.",
        1: "Les calculateurs médicaux et l'analyse des interactions médicamenteuses sont indispensables pendant mes gardes. Un outil fiable et rapide.",
        2: "Le chat IA m'aide à rester à jour sur les dernières recommandations HAS. Je le recommande à tous mes confrères hospitaliers.",
        3: "Les calculateurs médicaux sont pratiques pendant mes gardes. Tout est à portée de main, même hors-ligne. Un vrai gain de temps.",
        4: "Les cas cliniques interactifs m'ont préparée aux ECN. Interface intuitive et contenu de qualité. Je recommande !",
      },
    },
    faq: {
      title: "Questions",
      titleHighlight: "fréquentes",
      subtitle: "Tout ce que vous devez savoir avant de commencer",
      items: [
        { q: "L'application est-elle sécurisée ?", a: "Oui, Sclépios est 100% conforme RGPD. Vos données sont chiffrées et hébergées en Europe. Nous ne partageons jamais vos informations personnelles. Les conversations avec l'IA sont anonymisées et ne sont pas utilisées pour entraîner d'autres modèles." },
        { q: "L'IA est-elle fiable pour un usage médical ?", a: "Notre IA s'appuie sur des sources médicales officielles (HAS, SFAR, SRLF, recommandations européennes) et est régulièrement mise à jour. Elle est conçue comme un outil d'aide à la décision et d'apprentissage, pas comme un substitut au jugement clinique." },
        { q: "Est-ce que ça fonctionne hors-ligne ?", a: "Oui ! Les flashcards, QCM, fiches de révision et calculateurs médicaux sont disponibles hors-ligne une fois téléchargés. Seul le Chat IA nécessite une connexion internet." },
        { q: "Puis-je essayer gratuitement ?", a: "Absolument ! Vous pouvez créer un compte gratuit avec 3 messages IA par jour, ou démarrer un essai de 7 jours sans engagement et sans carte bancaire pour accéder à toutes les fonctionnalités premium." },
        { q: "Comment annuler mon abonnement ?", a: "Vous pouvez annuler à tout moment depuis vos paramètres de compte, en un seul clic. Aucun engagement, aucune question. Vous gardez l'accès jusqu'à la fin de votre période payée." },
        { q: "Pour quelles spécialités médicales ?", a: "Sclépios couvre toutes les spécialités : médecine générale, urgences, cardiologie, pneumologie, neurologie, pédiatrie, gériatrie, et plus encore." },
        { q: "Y a-t-il une application mobile ?", a: "Sclépios est une Progressive Web App (PWA) installable directement sur votre iPhone ou Android depuis le navigateur. Vous bénéficiez d'une expérience native avec les notifications push et le mode hors-ligne." },
        { q: "Comment fonctionne le code promo RETOUR30 ?", a: "Le code RETOUR30 vous offre -30% sur votre premier paiement d'abonnement Essential ou Pro. Entrez-le lors du paiement. Cette offre est limitée dans le temps." },
      ],
    },
    finalCTA: {
      title: "Prêt à transformer",
      titleHighlight: "votre pratique ?",
      subtitle: "Rejoignez 1 247 soignants qui utilisent déjà Sclépios IA pour réviser et pratiquer mieux",
      specialOffer: "OFFRE SPÉCIALE",
      discount: "-30% avec le code",
      validOn: "Offre valable sur Essential & Pro",
      cta: "Créer un compte gratuit",
      trial: "7 jours d'essai premium inclus",
      noCard: "Sans carte bancaire",
      noCommitment: "Sans engagement",
    },
    footer: {
      description: "L'assistant IA médical qui accompagne les soignants et étudiants en santé au quotidien.",
      newsletter: "Recevez nos conseils médicaux",
      newsletterSuccess: "Merci ! Vous recevrez nos conseils médicaux.",
      sslEncryption: "Chiffrement SSL",
      hostedEU: "Hébergé en UE",
      product: "Produit",
      chatIAMedical: "Chat IA Médical",
      pricingLink: "Tarifs",
      freeTrialLink: "Essai gratuit",
      legal: "Légal",
      terms: "Conditions d'utilisation",
      privacy: "Politique de confidentialité",
      legalNotice: "Mentions légales",
      copyright: "Tous droits réservés.",
      emailPlaceholder: "votre@email.fr",
    },
    notFound: {
      title: "Page introuvable",
      description: "La page que vous recherchez n'existe pas ou a été déplacée.",
      backHome: "Retour à l'accueil",
    },
    pricingPage: {
      seoTitle: "Tarifs - Choisissez votre formule",
      seoDescription: "Plans d'abonnement Sclepios : Free, Essential (4,99€), Pro (9,99€) et Team (19,99€). Choisissez la formule adaptée à vos besoins.",
      title: "Choisissez votre formule",
      subtitle: "De l'essai gratuit aux fonctionnalités avancées, trouvez le plan qui correspond à vos besoins d'apprentissage",
      headerTitle: "Tarifs",
      monthly: "Mensuel",
      yearly: "Annuel",
      promoCode: "Code RETOUR30 : -30% pendant 3 mois !",
      perMonth: "/mois",
      billedYearly: "Facturé {{amount}}/an",
      loading: "Chargement...",
      currentPlan: "Plan actuel",
      loginRequired: "Veuillez vous connecter pour continuer",
      paymentError: "Erreur lors de la création du paiement",
      plans: {
        free: { name: "Free", description: "Découvrir l'assistant IA", features: ["3 messages IA / jour", "Flashcards basiques", "Quiz quotidien", "Statistiques de base", "Accès forum communauté"], cta: "Commencer gratuitement" },
        essential: { name: "Essential", description: "Pour une utilisation régulière", badge: "Populaire", features: ["Conversations IA illimitées", "Flashcards illimitées avec SRS", "Quiz quotidien personnalisé", "Historique complet", "Support prioritaire", "Pas de publicité"], cta: "Choisir Essential" },
        pro: { name: "Pro", description: "Fonctionnalités avancées", badge: "Meilleur rapport", features: ["Tout de Essential, plus:", "Cas cliniques interactifs", "Révision Express (5 min)", "Statistiques avancées & insights", "Export PDF des fiches", "Mode examen blanc", "Challenges hebdomadaires"], cta: "Choisir Pro" },
        team: { name: "Team", description: "Pour équipes de 5 personnes", features: ["Tout de Pro, pour 5 utilisateurs", "Partage de decks", "Challenges d'équipe", "Tableau de bord équipe", "Gestion des membres", "Support prioritaire équipe"], cta: "Choisir Team" },
      },
      faq: {
        title: "Questions fréquentes",
        q1: "Puis-je changer de plan à tout moment ?",
        a1: "Oui, vous pouvez passer à un plan supérieur ou inférieur à tout moment. Les changements prennent effet immédiatement.",
        q2: "Comment fonctionne le plan Free ?",
        a2: "Le plan Free est gratuit sans limite de temps, avec 3 messages IA par jour. La limite se réinitialise à minuit. Vous pouvez upgrader quand vous voulez.",
        q3: "Puis-je annuler mon abonnement ?",
        a3: "Oui, vous pouvez annuler à tout moment depuis vos paramètres. Vous conservez l'accès jusqu'à la fin de la période payée.",
        q4: "Le plan Team inclut combien d'utilisateurs ?",
        a4: "Le plan Team inclut 5 utilisateurs pour 19,99€/mois (ou 15,99€/mois en annuel). Contactez-nous pour des équipes plus grandes.",
      },
      ctaHesitate: "Vous hésitez encore ? Commencez gratuitement, sans carte bancaire.",
      ctaDashboard: "Retour au dashboard",
      ctaCreateAccount: "Créer un compte gratuit",
    },
    achievements: {
      title: "Mes Accomplissements",
      studyTime: "Temps d'étude",
      flashcards: "Flashcards",
      streak: "Jours de suite",
      totalXP: "XP Total",
      badgesTab: "Badges",
      certificateTab: "Certificat",
      unlockedBadges: "Vos Badges Débloqués ({{count}})",
      badgesDescription: "Collection de vos accomplissements et réussites",
      noBadges: "Vous n'avez pas encore de badges. Continuez à apprendre pour en débloquer !",
      certificateTitle: "Certificat d'Excellence",
      certificateDescription: "Téléchargez votre certificat officiel d'accomplissement",
      certificateAttesting: "Attestant de votre engagement dans l'apprentissage médical continu",
      currentStreak: "Streak actuel",
      studyTimeLabel: "Temps d'étude",
      badgesObtained: "Badges obtenus",
      premiumProgress: "Progression vers le Certificat Premium",
      downloadCertificate: "Télécharger le Certificat PDF",
      streakRequired: "Atteignez un streak de 7 jours pour débloquer votre certificat",
      certificateDownloaded: "Certificat téléchargé avec succès ! 🎉",
      days: "jours",
      pdf: {
        title: "CERTIFICAT D'EXCELLENCE",
        grantedTo: "Décerné à",
        healthProfessional: "Professionnel de santé",
        streakText: "Pour avoir atteint un streak de {{streak}} jours",
        engagementText: "et démontré un engagement exceptionnel dans l'apprentissage médical continu",
        statsText: "{{flashcards}} flashcards créées • {{quizzes}} quiz complétés • {{xp}} XP gagnés",
        issuedOn: "Délivré le {{date}}",
        team: "L'équipe Sclepios",
      },
      loadingBadges: "Chargement des badges",
      certificatePreview: "Aperçu du certificat",
      statsSection: "Statistiques",
      pageNotFound: "Page non trouvée",
    },
  },
  en: {
    seoTitle: "Sclépios AI - Your intelligent medical AI assistant",
    seoDesc: "The #1 medical AI in France. AI chat adapted to your level, smart flashcards, MCQs, clinical cases. Free 7-day trial.",
    nav: {
      chatIA: "AI Chat",
      pricing: "Pricing",
      dashboard: "Dashboard",
      login: "Login",
      freeTrial: "Free trial",
    },
    hero: {
      badge: "Approved by 1200+ healthcare professionals",
      title: "Your AI medical assistant,",
      titleHighlight: "always in your pocket",
      subtitle: "From student to practitioner, study and practice better with the most advanced medical AI.",
      benefit1: "AI medical chat adapted to your level",
      benefit2: "Smart flashcards & personalized MCQs",
      benefit3: "Prescription analysis & medical calculators",
      ctaPrimary: "Try 7 days free",
      ctaSecondary: "Discover AI Chat",
      badgeSecure: "Secure data",
      badgeNoCard: "No credit card",
      badgeUsers: "1200+ professionals",
      mockupTitles: {
        chat: "Medical AI Chat",
        dashboard: "Dashboard",
        flashcards: "Smart Flashcards",
        qcm: "Personalized MCQs",
      },
      viewScreenshot: "View screenshot {{index}}",
      chatIA24: "AI Chat",
      flashcardsCount: "+15,000",
    },
    trust: {
      rating: "Average rating",
      activeUsers: "Active professionals",
      timePerPatient: "Time saved per patient",
      rgpd: "GDPR compliant",
    },
    features: {
      title: "Everything you need,",
      titleHighlight: "in one app",
      subtitle: "Powerful tools designed for healthcare professionals and students",
      items: {
        chatIA: { title: "Medical AI Chat", description: "Instant answers to all your medical questions, adapted to your level" },
        flashcards: { title: "Smart Flashcards", description: "Optimized memorization with spaced repetition algorithm" },
        qcm: { title: "MCQ & Quizzes", description: "10,000+ questions to practice for exams" },
        clinical: { title: "Clinical Cases", description: "Training with realistic and corrected cases" },
        prescriptions: { title: "Prescription Analysis", description: "Automatic verification of interactions and dosages" },
        calculators: { title: "50+ Calculators", description: "All medical scores at your fingertips" },
        sheets: { title: "Revision Sheets", description: "Clear summaries by medical specialty" },
        express: { title: "Express Review", description: "5-minute sessions to review between patients" },
      },
    },
    chatSection: {
      badge: "Key Feature",
      title: "Medical AI Chat",
      titleHighlight: "Intelligent",
      subtitle: "Ask any medical question and get a clear, structured answer adapted to your practice level.",
      feature1: "Adapted to your level (student, nurse, doctor)",
      feature2: "Reliable medical sources (guidelines, recommendations...)",
      feature3: "Available 24/7, even offline",
      cta: "Try AI Chat",
      assistantName: "Sclepios Assistant",
      online: "Online",
      inputPlaceholder: "Ask your medical question...",
      viewExample: "View example {{index}}",
    },
    pricing: {
      title: "Simple and",
      titleHighlight: "transparent pricing",
      subtitle: "Choose the plan that fits your needs. Cancel anytime.",
      monthly: "Monthly",
      yearly: "Yearly",
      promoCode: "Code RETOUR30: -30% for 3 months!",
      withPromoCode: "with code RETOUR30",
      billedYearly: "Billed {{amount}}/year",
      mostPopular: "Most popular",
      teamPlan: "Team plan for institutions",
      teamPrice: "€19.99/month for 5 users",
      contactUs: "Contact us",
      plans: {
        free: {
          name: "Free",
          description: "Discover the application",
          features: ["3 AI messages per day", "Daily quiz", "Community forum", "Basic flashcards"],
          cta: "Create an account",
        },
        essential: {
          name: "Essential",
          description: "For students",
          features: ["Unlimited AI chat", "Unlimited flashcards", "All MCQs", "Basic statistics", "Offline mode"],
          cta: "Choose Essential",
        },
        pro: {
          name: "Pro",
          description: "For professionals",
          features: ["Everything in Essential +", "Interactive clinical cases", "Express Review 5min", "Advanced statistics", "Prescription analysis", "PDF export"],
          cta: "Choose Pro",
        },
      },
    },
    testimonials: {
      title: "They use Sclepios",
      titleHighlight: "every day",
      subtitle: "Join over 1,200 satisfied healthcare professionals",
      verified: "Verified",
      viewTestimonial: "View testimonial {{index}}",
      statsRating: "Average rating",
      statsUsers: "Active users",
      statsFlashcards: "Flashcards created",
      roles: {
        emergencyDoctor: "Emergency physician",
        hospitalDoctor: "Hospital physician",
        icuNurse: "ICU nurse",
        cardiologyIntern: "Cardiology intern",
      },
      texts: {
        0: "Sclepios has become my daily companion in the ER. The AI saves me precious time for decision-making in critical situations.",
        1: "The medical calculators and drug interaction analysis are essential during my shifts. A reliable and fast tool.",
        2: "The AI chat helps me stay up to date with the latest HAS guidelines. I recommend it to all my hospital colleagues.",
        3: "The medical calculators are practical during my shifts. Everything is at hand, even offline. A real time saver.",
        4: "The interactive clinical cases prepared me for the ECN. Intuitive interface and quality content. I recommend it!",
      },
    },
    faq: {
      title: "Frequently",
      titleHighlight: "asked questions",
      subtitle: "Everything you need to know before getting started",
      items: [
        { q: "Is the application secure?", a: "Yes, Sclepios is 100% GDPR compliant. Your data is encrypted and hosted in Europe. We never share your personal information. AI conversations are anonymized and not used to train other models." },
        { q: "Is the AI reliable for medical use?", a: "Our AI relies on official medical sources (guidelines, European recommendations) and is regularly updated. It is designed as a decision-support and learning tool, not as a substitute for clinical judgment." },
        { q: "Does it work offline?", a: "Yes! Flashcards, MCQs, revision sheets and medical calculators are available offline once downloaded. Only AI Chat requires an internet connection." },
        { q: "Can I try it for free?", a: "Absolutely! You can create a free account with 3 AI messages per day, or start a 7-day trial with no commitment and no credit card to access all premium features." },
        { q: "How do I cancel my subscription?", a: "You can cancel anytime from your account settings, in one click. No commitment, no questions asked. You keep access until the end of your paid period." },
        { q: "For which medical specialties?", a: "Sclepios covers all specialties: general medicine, emergency, cardiology, pulmonology, neurology, pediatrics, geriatrics, and more." },
        { q: "Is there a mobile app?", a: "Sclepios is a Progressive Web App (PWA) installable directly on your iPhone or Android from the browser. You get a native experience with push notifications and offline mode." },
        { q: "How does the RETOUR30 promo code work?", a: "The RETOUR30 code gives you -30% on your first payment for an Essential or Pro subscription. Enter it at checkout. This offer is limited in time." },
      ],
    },
    finalCTA: {
      title: "Ready to transform",
      titleHighlight: "your practice?",
      subtitle: "Join 1,247 healthcare professionals already using Sclepios AI to study and practice better",
      specialOffer: "SPECIAL OFFER",
      discount: "-30% with code",
      validOn: "Valid on Essential & Pro",
      cta: "Create a free account",
      trial: "7-day premium trial included",
      noCard: "No credit card",
      noCommitment: "No commitment",
    },
    footer: {
      description: "The AI medical assistant that supports healthcare professionals and health students every day.",
      newsletter: "Get our medical tips",
      newsletterSuccess: "Thank you! You'll receive our medical tips.",
      sslEncryption: "SSL Encryption",
      hostedEU: "Hosted in EU",
      product: "Product",
      chatIAMedical: "Medical AI Chat",
      pricingLink: "Pricing",
      freeTrialLink: "Free trial",
      legal: "Legal",
      terms: "Terms of use",
      privacy: "Privacy policy",
      legalNotice: "Legal notice",
      copyright: "All rights reserved.",
      emailPlaceholder: "your@email.com",
    },
    notFound: {
      title: "Page not found",
      description: "The page you are looking for does not exist or has been moved.",
      backHome: "Back to home",
    },
    pricingPage: {
      seoTitle: "Pricing - Choose your plan",
      seoDescription: "Sclepios subscription plans: Free, Essential (€4.99), Pro (€9.99) and Team (€19.99). Choose the plan adapted to your needs.",
      title: "Choose your plan",
      subtitle: "From free trial to advanced features, find the plan that matches your learning needs",
      headerTitle: "Pricing",
      monthly: "Monthly",
      yearly: "Yearly",
      promoCode: "Code RETOUR30: -30% for 3 months!",
      perMonth: "/month",
      billedYearly: "Billed {{amount}}/year",
      loading: "Loading...",
      currentPlan: "Current plan",
      loginRequired: "Please log in to continue",
      paymentError: "Error creating payment",
      plans: {
        free: { name: "Free", description: "Discover the AI assistant", features: ["3 AI messages / day", "Basic flashcards", "Daily quiz", "Basic statistics", "Community forum access"], cta: "Start for free" },
        essential: { name: "Essential", description: "For regular use", badge: "Popular", features: ["Unlimited AI conversations", "Unlimited flashcards with SRS", "Personalized daily quiz", "Complete history", "Priority support", "No ads"], cta: "Choose Essential" },
        pro: { name: "Pro", description: "Advanced features", badge: "Best value", features: ["Everything in Essential, plus:", "Interactive clinical cases", "Express Review (5 min)", "Advanced statistics & insights", "PDF export of sheets", "Mock exam mode", "Weekly challenges"], cta: "Choose Pro" },
        team: { name: "Team", description: "For teams of 5", features: ["Everything in Pro, for 5 users", "Deck sharing", "Team challenges", "Team dashboard", "Member management", "Team priority support"], cta: "Choose Team" },
      },
      faq: {
        title: "Frequently asked questions",
        q1: "Can I change my plan anytime?",
        a1: "Yes, you can upgrade or downgrade at any time. Changes take effect immediately.",
        q2: "How does the Free plan work?",
        a2: "The Free plan is free with no time limit, with 3 AI messages per day. The limit resets at midnight. You can upgrade whenever you want.",
        q3: "Can I cancel my subscription?",
        a3: "Yes, you can cancel at any time from your settings. You keep access until the end of your paid period.",
        q4: "How many users does the Team plan include?",
        a4: "The Team plan includes 5 users for €19.99/month (or €15.99/month yearly). Contact us for larger teams.",
      },
      ctaHesitate: "Still hesitating? Start for free, no credit card required.",
      ctaDashboard: "Back to dashboard",
      ctaCreateAccount: "Create a free account",
    },
    achievements: {
      title: "My Achievements",
      studyTime: "Study time",
      flashcards: "Flashcards",
      streak: "Day streak",
      totalXP: "Total XP",
      badgesTab: "Badges",
      certificateTab: "Certificate",
      unlockedBadges: "Your Unlocked Badges ({{count}})",
      badgesDescription: "Collection of your achievements and successes",
      noBadges: "You don't have any badges yet. Keep learning to unlock them!",
      certificateTitle: "Certificate of Excellence",
      certificateDescription: "Download your official achievement certificate",
      certificateAttesting: "Attesting to your commitment to continuous medical learning",
      currentStreak: "Current streak",
      studyTimeLabel: "Study time",
      badgesObtained: "Badges obtained",
      premiumProgress: "Progress to Premium Certificate",
      downloadCertificate: "Download PDF Certificate",
      streakRequired: "Reach a 7-day streak to unlock your certificate",
      certificateDownloaded: "Certificate downloaded successfully! 🎉",
      days: "days",
      pdf: {
        title: "CERTIFICATE OF EXCELLENCE",
        grantedTo: "Granted to",
        healthProfessional: "Healthcare professional",
        streakText: "For reaching a {{streak}}-day streak",
        engagementText: "and demonstrating exceptional commitment to continuous medical learning",
        statsText: "{{flashcards}} flashcards created • {{quizzes}} quizzes completed • {{xp}} XP earned",
        issuedOn: "Issued on {{date}}",
        team: "The Sclepios Team",
      },
      loadingBadges: "Loading badges",
      certificatePreview: "Certificate preview",
      statsSection: "Statistics",
      pageNotFound: "Page not found",
    },
  },
  es: {
    seoTitle: "Sclépios IA - Tu asistente médico IA inteligente",
    seoDesc: "La IA médica #1 en Francia. Chat IA adaptado a tu nivel, flashcards inteligentes, QCM, casos clínicos. Prueba gratuita 7 días.",
    nav: {
      chatIA: "Chat IA",
      pricing: "Precios",
      dashboard: "Panel de control",
      login: "Iniciar sesión",
      freeTrial: "Prueba gratis",
    },
    hero: {
      badge: "Aprobado por +1200 profesionales de la salud",
      title: "Tu asistente médico IA,",
      titleHighlight: "siempre en tu bolsillo",
      subtitle: "Del estudiante al profesional, estudia y practica mejor con la IA médica más avanzada.",
      benefit1: "Chat IA médico adaptado a tu nivel",
      benefit2: "Tarjetas inteligentes y MCQ personalizados",
      benefit3: "Análisis de recetas y cálculos médicos",
      ctaPrimary: "Probar 7 días gratis",
      ctaSecondary: "Descubrir el Chat IA",
      badgeSecure: "Datos seguros",
      badgeNoCard: "Sin tarjeta de crédito",
      badgeUsers: "1200+ profesionales",
      mockupTitles: {
        chat: "Chat IA Médico",
        dashboard: "Panel de control",
        flashcards: "Tarjetas Inteligentes",
        qcm: "MCQ Personalizados",
      },
      viewScreenshot: "Ver captura {{index}}",
      chatIA24: "Chat IA",
      flashcardsCount: "+15.000",
    },
    trust: {
      rating: "Nota media",
      activeUsers: "Profesionales activos",
      timePerPatient: "Ahorro por paciente",
      rgpd: "Cumple RGPD",
    },
    features: {
      title: "Todo lo que necesitas,",
      titleHighlight: "en una sola app",
      subtitle: "Herramientas poderosas diseñadas para profesionales de la salud y estudiantes",
      items: {
        chatIA: { title: "Chat IA Médico", description: "Respuestas instantáneas a todas tus preguntas médicas, adaptadas a tu nivel" },
        flashcards: { title: "Tarjetas Inteligentes", description: "Memorización optimizada con algoritmo de repetición espaciada" },
        qcm: { title: "MCQ y Quiz", description: "10.000+ preguntas para practicar para los exámenes" },
        clinical: { title: "Casos Clínicos", description: "Entrenamiento con casos realistas y corregidos" },
        prescriptions: { title: "Análisis de Recetas", description: "Verificación automática de interacciones y dosis" },
        calculators: { title: "50+ Calculadoras", description: "Todas las puntuaciones médicas al alcance de tu mano" },
        sheets: { title: "Fichas de Repaso", description: "Resúmenes claros por especialidad médica" },
        express: { title: "Repaso Express", description: "Sesiones de 5 min para repasar entre pacientes" },
      },
    },
    chatSection: {
      badge: "Característica Principal",
      title: "Chat IA Médico",
      titleHighlight: "Inteligente",
      subtitle: "Haz cualquier pregunta médica y obtén una respuesta clara, estructurada y adaptada a tu nivel de práctica.",
      feature1: "Adaptado a tu nivel (estudiante, enfermero, médico)",
      feature2: "Fuentes médicas confiables (guías, recomendaciones...)",
      feature3: "Disponible 24/7, incluso sin conexión",
      cta: "Probar el Chat IA",
      assistantName: "Asistente Sclepios",
      online: "En línea",
      inputPlaceholder: "Haz tu pregunta médica...",
      viewExample: "Ver ejemplo {{index}}",
    },
    pricing: {
      title: "Precios simples y",
      titleHighlight: "transparentes",
      subtitle: "Elige el plan adaptado a tus necesidades. Cancela en cualquier momento.",
      monthly: "Mensual",
      yearly: "Anual",
      promoCode: "Código RETOUR30: ¡-30% durante 3 meses!",
      withPromoCode: "con código RETOUR30",
      billedYearly: "Facturado {{amount}}/año",
      mostPopular: "Más popular",
      teamPlan: "Plan Team para establecimientos",
      teamPrice: "19,99€/mes para 5 usuarios",
      contactUs: "Contáctanos",
      plans: {
        free: {
          name: "Gratuito",
          description: "Para descubrir la aplicación",
          features: ["3 mensajes IA por día", "Quiz diario", "Foro comunitario", "Tarjetas básicas"],
          cta: "Crear cuenta",
        },
        essential: {
          name: "Essential",
          description: "Para estudiantes",
          features: ["Chat IA ilimitado", "Tarjetas ilimitadas", "Todos los MCQ", "Estadísticas básicas", "Modo sin conexión"],
          cta: "Elegir Essential",
        },
        pro: {
          name: "Pro",
          description: "Para profesionales",
          features: ["Todo de Essential +", "Casos clínicos interactivos", "Repaso Express 5min", "Estadísticas avanzadas", "Análisis de recetas", "Exportar PDF"],
          cta: "Elegir Pro",
        },
      },
    },
    testimonials: {
      title: "Usan Sclepios",
      titleHighlight: "a diario",
      subtitle: "Únete a más de 1.200 profesionales de la salud satisfechos",
      verified: "Verificado",
      viewTestimonial: "Ver testimonio {{index}}",
      statsRating: "Nota media",
      statsUsers: "Usuarios activos",
      statsFlashcards: "Tarjetas creadas",
      roles: {
        emergencyDoctor: "Médico de urgencias",
        hospitalDoctor: "Médico hospitalario",
        icuNurse: "Enfermero de UCI",
        cardiologyIntern: "Interno de cardiología",
      },
      texts: {
        0: "Sclepios se ha convertido en mi compañero diario en urgencias. La IA me ahorra un tiempo valioso para la toma de decisiones en situaciones críticas.",
        1: "Las calculadoras médicas y el análisis de interacciones medicamentosas son imprescindibles durante mis guardias. Una herramienta fiable y rápida.",
        2: "El chat IA me ayuda a mantenerme al día con las últimas guías HAS. Lo recomiendo a todos mis colegas hospitalarios.",
        3: "Las calculadoras médicas son prácticas durante mis guardias. Todo está al alcance, incluso sin conexión. Un verdadero ahorro de tiempo.",
        4: "Los casos clínicos interactivos me prepararon para el ECN. Interfaz intuitiva y contenido de calidad. ¡Lo recomiendo!",
      },
    },
    faq: {
      title: "Preguntas",
      titleHighlight: "frecuentes",
      subtitle: "Todo lo que necesitas saber antes de empezar",
      items: [
        { q: "¿La aplicación es segura?", a: "Sí, Sclepios cumple 100% con el RGPD. Tus datos están cifrados y alojados en Europa. Nunca compartimos tu información personal." },
        { q: "¿Es fiable la IA para uso médico?", a: "Nuestra IA se basa en fuentes médicas oficiales y se actualiza regularmente. Está diseñada como una herramienta de apoyo a la decisión y aprendizaje, no como sustituto del juicio clínico." },
        { q: "¿Funciona sin conexión?", a: "¡Sí! Las tarjetas, MCQ, fichas de repaso y calculadoras médicas están disponibles sin conexión una vez descargadas. Solo el Chat IA requiere conexión a internet." },
        { q: "¿Puedo probarlo gratis?", a: "¡Por supuesto! Puedes crear una cuenta gratuita con 3 mensajes IA por día, o iniciar una prueba de 7 días sin compromiso y sin tarjeta de crédito." },
        { q: "¿Cómo cancelo mi suscripción?", a: "Puedes cancelar en cualquier momento desde la configuración de tu cuenta, con un solo clic. Sin compromiso, sin preguntas." },
        { q: "¿Para qué especialidades médicas?", a: "Sclepios cubre todas las especialidades: medicina general, urgencias, cardiología, neumología, neurología, pediatría, geriatría y más." },
        { q: "¿Hay una aplicación móvil?", a: "Sclepios es una Progressive Web App (PWA) instalable directamente en tu iPhone o Android desde el navegador." },
        { q: "¿Cómo funciona el código promo RETOUR30?", a: "El código RETOUR30 te da -30% en tu primer pago de suscripción Essential o Pro. Ingrésalo al pagar." },
      ],
    },
    finalCTA: {
      title: "¿Listo para transformar",
      titleHighlight: "tu práctica?",
      subtitle: "Únete a 1.247 profesionales de la salud que ya usan Sclepios IA para estudiar y practicar mejor",
      specialOffer: "OFERTA ESPECIAL",
      discount: "-30% con el código",
      validOn: "Válido en Essential y Pro",
      cta: "Crear una cuenta gratis",
      trial: "7 días de prueba premium incluidos",
      noCard: "Sin tarjeta de crédito",
      noCommitment: "Sin compromiso",
    },
    footer: {
      description: "El asistente IA médico que acompaña a profesionales y estudiantes de salud a diario.",
      newsletter: "Recibe nuestros consejos médicos",
      newsletterSuccess: "¡Gracias! Recibirás nuestros consejos médicos.",
      sslEncryption: "Cifrado SSL",
      hostedEU: "Alojado en la UE",
      product: "Producto",
      chatIAMedical: "Chat IA Médico",
      pricingLink: "Precios",
      freeTrialLink: "Prueba gratis",
      legal: "Legal",
      terms: "Condiciones de uso",
      privacy: "Política de privacidad",
      legalNotice: "Aviso legal",
      copyright: "Todos los derechos reservados.",
      emailPlaceholder: "tu@correo.com",
    },
    notFound: {
      title: "Página no encontrada",
      description: "La página que buscas no existe o ha sido movida.",
      backHome: "Volver al inicio",
    },
    pricingPage: {
      seoTitle: "Precios - Elige tu plan",
      seoDescription: "Planes de suscripción Sclepios: Free, Essential (4,99€), Pro (9,99€) y Team (19,99€).",
      title: "Elige tu plan",
      subtitle: "De la prueba gratuita a las funcionalidades avanzadas, encuentra el plan que se adapte a tus necesidades",
      headerTitle: "Precios",
      monthly: "Mensual",
      yearly: "Anual",
      promoCode: "Código RETOUR30: ¡-30% durante 3 meses!",
      perMonth: "/mes",
      billedYearly: "Facturado {{amount}}/año",
      loading: "Cargando...",
      currentPlan: "Plan actual",
      loginRequired: "Inicia sesión para continuar",
      paymentError: "Error al crear el pago",
      plans: {
        free: { name: "Free", description: "Descubrir el asistente IA", features: ["3 mensajes IA / día", "Tarjetas básicas", "Quiz diario", "Estadísticas básicas", "Acceso foro comunidad"], cta: "Empezar gratis" },
        essential: { name: "Essential", description: "Para uso regular", badge: "Popular", features: ["Conversaciones IA ilimitadas", "Tarjetas ilimitadas con SRS", "Quiz diario personalizado", "Historial completo", "Soporte prioritario", "Sin publicidad"], cta: "Elegir Essential" },
        pro: { name: "Pro", description: "Funcionalidades avanzadas", badge: "Mejor relación", features: ["Todo de Essential, más:", "Casos clínicos interactivos", "Repaso Express (5 min)", "Estadísticas avanzadas e insights", "Exportar fichas en PDF", "Modo examen", "Retos semanales"], cta: "Elegir Pro" },
        team: { name: "Team", description: "Para equipos de 5", features: ["Todo de Pro, para 5 usuarios", "Compartir mazos", "Retos de equipo", "Panel de equipo", "Gestión de miembros", "Soporte prioritario equipo"], cta: "Elegir Team" },
      },
      faq: {
        title: "Preguntas frecuentes",
        q1: "¿Puedo cambiar de plan en cualquier momento?",
        a1: "Sí, puedes subir o bajar de plan en cualquier momento. Los cambios tienen efecto inmediato.",
        q2: "¿Cómo funciona el plan Free?",
        a2: "El plan Free es gratuito sin límite de tiempo, con 3 mensajes IA por día. El límite se reinicia a medianoche.",
        q3: "¿Puedo cancelar mi suscripción?",
        a3: "Sí, puedes cancelar en cualquier momento desde tu configuración. Mantienes el acceso hasta el final del período pagado.",
        q4: "¿Cuántos usuarios incluye el plan Team?",
        a4: "El plan Team incluye 5 usuarios por 19,99€/mes (o 15,99€/mes anual). Contáctanos para equipos más grandes.",
      },
      ctaHesitate: "¿Aún dudas? Empieza gratis, sin tarjeta de crédito.",
      ctaDashboard: "Volver al panel",
      ctaCreateAccount: "Crear cuenta gratis",
    },
    achievements: {
      title: "Mis Logros",
      studyTime: "Tiempo de estudio",
      flashcards: "Tarjetas",
      streak: "Días seguidos",
      totalXP: "XP Total",
      badgesTab: "Insignias",
      certificateTab: "Certificado",
      unlockedBadges: "Tus Insignias Desbloqueadas ({{count}})",
      badgesDescription: "Colección de tus logros y éxitos",
      noBadges: "Aún no tienes insignias. ¡Sigue aprendiendo para desbloquearlas!",
      certificateTitle: "Certificado de Excelencia",
      certificateDescription: "Descarga tu certificado oficial de logros",
      certificateAttesting: "Atestiguando tu compromiso con el aprendizaje médico continuo",
      currentStreak: "Racha actual",
      studyTimeLabel: "Tiempo de estudio",
      badgesObtained: "Insignias obtenidas",
      premiumProgress: "Progreso hacia el Certificado Premium",
      downloadCertificate: "Descargar Certificado PDF",
      streakRequired: "Alcanza una racha de 7 días para desbloquear tu certificado",
      certificateDownloaded: "¡Certificado descargado con éxito! 🎉",
      days: "días",
      pdf: {
        title: "CERTIFICADO DE EXCELENCIA",
        grantedTo: "Otorgado a",
        healthProfessional: "Profesional de la salud",
        streakText: "Por alcanzar una racha de {{streak}} días",
        engagementText: "y demostrar un compromiso excepcional con el aprendizaje médico continuo",
        statsText: "{{flashcards}} tarjetas creadas • {{quizzes}} quiz completados • {{xp}} XP ganados",
        issuedOn: "Emitido el {{date}}",
        team: "El equipo Sclepios",
      },
      loadingBadges: "Cargando insignias",
      certificatePreview: "Vista previa del certificado",
      statsSection: "Estadísticas",
      pageNotFound: "Página no encontrada",
    },
  },
};
